var nl_BE = {};
module['exports'] = nl_BE;
nl_BE.title = "Dutch (Belgium)";
nl_BE.address = require("./address");
nl_BE.company = require("./company");
nl_BE.internet = require("./internet");
nl_BE.name = require("./name");
nl_BE.phone_number = require("./phone_number");